import _ from 'lodash'
import { withDependencies, multi } from '@wix/thunderbolt-ioc'
import type { IModelUpdatesInvoker } from 'thunderbolt-ds-carmi-root'
import type { IModelUpdatesHandlersImplementor, IViewerBatchingManager } from './types'
import { ModelUpdatesHandlersImplementor, ViewerBatchingManagerSymbol } from './symbols'

export const ModelUpdatesInvoker = withDependencies(
	[multi(ModelUpdatesHandlersImplementor), ViewerBatchingManagerSymbol],
	(
		modelUpdatesHandlersImplementorArray: Array<IModelUpdatesHandlersImplementor<any>>,
		viewerBatchingManager: IViewerBatchingManager
	): IModelUpdatesInvoker => {
		const modelUpdateHandlers = _(modelUpdatesHandlersImplementorArray)
			.groupBy('featureName') // allow same feature to bind multiple 'ModelUpdatesHandlersImplementor's
			.mapValues((modelUpdatesHandlersImplementors) =>
				_.assign({}, ..._.map(modelUpdatesHandlersImplementors, 'handlers'))
			)
			.value()

		return {
			invokeModelUpdateHandler: (featureName, handlerName, data) => {
				const handler = modelUpdateHandlers[featureName]?.[handlerName]
				if (handler) {
					const promise = handler(data)
					if (promise) {
						viewerBatchingManager.addRenderBlockingTask(promise)
					}
				} else {
					throw new Error(`ModelUpdateHandler ${featureName}.${handlerName} not found!`)
				}
			},
		}
	}
)
